import * as z from "zod/mini"

import { getPlainOrLexicalTextCharacterCount } from "../utilities/lexical"

export const htmlEmbedMaxLength = 100_000
export const htmlEmbedMinHeight = 100
export const htmlEmbedMaxHeight = 2000

export const htmlEmbedBlockContentSchema = z.object({
	html: z.string().check(z.maxLength(htmlEmbedMaxLength)),
	height: z.int().check(z.minimum(htmlEmbedMinHeight), z.maximum(htmlEmbedMaxHeight)),
})

export const productHighlightProductTypes = [
	"course",
	"downloadable",
	"video",
	"session",
	"event",
	"membership",
] as const

export const productListTypes = ["course", "video", "downloadable", "session", "event", "membership"] as const

export const productBlockLinkTargets = ["product-page", "checkout"] as const

export const blogPostsBlockLayouts = ["grid", "list"] as const
export const blogPostsBlockMaxPostCount = 12

export const landingPageCopyCharacterLimits = {
	shortLabel: 120,
	title: 300,
	description: 2_000,
	itemDescription: 3_000,
	body: 6_000,
} as const

export const landingPageCopyCharacterLimit = landingPageCopyCharacterLimits.description

/** The SEO description a website page can set instead of falling back to the academy description. */
export const landingPagePageDescriptionMaxLength = 500

export const landingPageCopySchema = (limit: number) =>
	z.string().check(
		z.trim(),
		z.refine<string>(value => getPlainOrLexicalTextCharacterCount(value) <= limit, {
			message: `Must be ${limit} characters or fewer.`,
		}),
	)
export const lenientLandingPageCopySchema = (_limit: number) => z.string().check(z.trim())

export const landingImageSchema = z.object({
	url: z.string().check(z.trim()),
	alt: z.optional(z.string().check(z.trim())),
})

export const landingEmbeddedVideoSchema = z.discriminatedUnion("type", [
	z.object({
		type: z.literal("youtube"),
		videoId: z.string().check(z.trim()),
	}),
	z.object({
		type: z.literal("vimeo"),
		videoId: z.string().check(z.trim()),
	}),
])

const landingPageLinkTargetShape = { openInNewTab: z.optional(z.boolean()) }

export const landingPageLinkSchema = z.discriminatedUnion("type", [
	z.object({ type: z.literal("page"), path: z.string().check(z.trim()), ...landingPageLinkTargetShape }),
	z.object({ type: z.literal("academy"), path: z.string().check(z.trim()), ...landingPageLinkTargetShape }),
	z.object({ type: z.literal("custom"), url: z.string().check(z.trim()), ...landingPageLinkTargetShape }),
])

export const footerSocialPlatforms = [
	"x",
	"facebook",
	"instagram",
	"tiktok",
	"youtube",
	"linkedin",
	"substack",
] as const

export const landingPageTextSizes = ["small", "medium", "large", "extra-large"] as const
